var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmsProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 52,
    viewBox: "0 0 56 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4899 30.7883C42.0412 31.8478 43.8851 32.5 45.9066 32.5C51.2886 32.5 55.6566 28.132 55.6566 22.75C55.6566 18.2498 52.5886 14.4972 48.4416 13.377C48.8944 12.2547 49.1566 11.0348 49.1566 9.75C49.1566 4.368 44.7886 0 39.4066 0C34.0246 0 29.6566 4.368 29.6566 9.75C29.6566 11.0348 29.9188 12.2525 30.3716 13.377C27.8539 14.0573 25.7436 15.717 24.4674 17.9183L40.2906 27.807L38.3232 30.9552V49.8333H31.8233V30.1817L35.0104 32.1707L37.3049 28.4982L18.8233 16.9433L0.34375 28.496L2.63825 32.1685L5.82542 30.1795V49.8333H1.49208V52H53.4921V49.8333H40.4921V30.7883H40.4899ZM23.1566 49.8333H14.4899V39H23.1566V49.8333Z",
    fill: "#8BC34A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.3128,
    height: 52,
    fill: "white",
    transform: "translate(0.34375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmsProfile);
export default __webpack_public_path__ + "static/media/farms-profile.b95b556b2e9fe13b77d7692cad4ab621.svg";
export { ForwardRef as ReactComponent };